const AccordionDescription = [
  'Inköpspriset är baserat på liknande bilar på marknaden som är till salu just nu eller nyligen har legat ute till försäljning.',
  'Vi tar med en massa parametrar om just din bil för att ge ett så pricksäkert pris som möjligt, där vår tjänst hela tiden utvecklas och förbättras.',
  'Inköpspriset du får här är en indikation på bilens värde, men det slutgiltiga priset kan gå både upp och ned beroende på bilens skick och andra faktorer vi inte kunnat ta hänsyn till i denna värdering. För att kunna ge ett slutgiltigt inköpspris behöver vi se din bil och dess servicehistorik.',
  'Finns det för lite underlag på marknaden om just din bil kan det vara svårt att ge ett inköpspris. Ta då gärna kontakt med oss så kikar vi närmare på din bil i bilhallen istället.',
];

const CalculationDescription = `
  <div class="waykevaluation-content">
    ${AccordionDescription.map(
      (d, i) =>
        `<p class="waykevaluation-content__p${
          i === 0 ? ' waykevaluation-text waykevaluation-text--font-medium' : ''
        }">${d}</p>`
    ).join('')}
  </div>`;

export default CalculationDescription;
